var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"2701fb085478f2aac993fc8216882e84f4b0b425"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/employers/find-developers";

import * as Sentry from '@sentry/nextjs'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

Sentry.init({
  dsn: SENTRY_DSN,
  enableTracing: process.env.SENTRY_ENABLE_TRACING === 'true',
  tracesSampleRate: parseFloat(process.env.SENTRY_TRACE_SAMPLING || 1),
  environment: process.env.NODE_ENV,
  ignoreTransactions: ['partial/match'],
})
